import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const JACK = {
    name: "Jack Shelton",
    role: "Attorney",
    credentials: [
        "LL.M., Admiralty & Maritime Law · Tulane, 2011 (cum laude)",
        "J.D. · University of Tennessee College of Law, 2010 (cum laude)"
    ],
    bio: "Jack represents individuals, families, and closely-held companies on the estate, real property, and business matters that shape long-term outcomes, from a single negotiated agreement to ongoing representation as outside general counsel.",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_attorney-site-build/artifacts/wq0muyna_Jack%20Headshot.jpeg",
    href: "/people"
};

export default function AttorneyPreview() {
    return (
        <section
            data-testid="attorney-preview"
            className="bg-white border-t border-acre-line"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                    {/* Kicker + title */}
                    <div className="lg:col-span-4">
                        <div className="flex items-center mb-6">
                            <span className="acre-tick" />
                            <span className="text-[11px] uppercase tracking-[0.28em] text-acre-muted">
                                Meet the Attorney
                            </span>
                        </div>
                        <h2 className="font-serif-display text-4xl lg:text-5xl text-acre-secondary leading-tight">
                            The work is done by the attorney you hire.
                        </h2>
                        <p className="mt-6 text-acre-muted leading-relaxed">
                            No delegation, no distance. Every matter is handled from first conversation through final signature.
                        </p>
                    </div>

                    {/* Attorney card */}
                    <div className="lg:col-span-8">
                        <Link
                            to={JACK.href}
                            data-testid="attorney-preview-card"
                            className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start"
                        >
                            <div className="md:col-span-5">
                                <div className="relative aspect-[4/5] overflow-hidden bg-acre-bg">
                                    <img
                                        src={JACK.photo}
                                        alt={`Headshot of ${JACK.name}`}
                                        className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
                                        loading="lazy"
                                    />
                                </div>
                            </div>

                            <div className="md:col-span-7 md:pt-4">
                                <div className="flex items-baseline justify-between gap-4">
                                    <h3 className="font-serif-display text-3xl lg:text-4xl text-acre-ink group-hover:text-acre-secondary transition-colors">
                                        {JACK.name}
                                    </h3>
                                    <ArrowUpRight
                                        size={22}
                                        strokeWidth={1.5}
                                        className="text-acre-muted group-hover:text-acre-secondary group-hover:-translate-y-1 group-hover:translate-x-1 transition-all shrink-0"
                                    />
                                </div>
                                <div className="mt-2 text-[11px] uppercase tracking-[0.28em] text-acre-secondary">
                                    {JACK.role}
                                </div>

                                <ul className="mt-6 space-y-1.5 text-sm text-acre-muted">
                                    {JACK.credentials.map((c) => (
                                        <li key={c}>{c}</li>
                                    ))}
                                </ul>

                                <p className="mt-6 text-acre-muted leading-relaxed">
                                    {JACK.bio}
                                </p>

                                <div className="mt-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold text-acre-ink border-b border-acre-secondary pb-1 group-hover:text-acre-secondary transition-colors">
                                    Full Biography
                                    <ArrowUpRight size={13} strokeWidth={2} />
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
